import CLogger from '../logger/CLogger.js'
import Dexie from 'dexie';

const db = new Dexie('studioDB');

db.version(1).stores({
  pageEditorCanvas: '++id,value',
  pageEditorModelData: '++id,value',
  pageEditor: '++id,value',
});

db.open().catch((err) => {
  CLogger.error("Dexie database open failed:", err);
});

export default db;